export default {
  data: function () {
    return {
      formInputArray: [],
      resultForm: {}
    }
  },
  mounted: function () {
    setTimeout(this.checkAll, 5000);
  },
  methods: {
    registerInput: function (inputInfo) {
      inputInfo.callbackFunction()
      this.formInputArray.push({
        id: inputInfo.id,
        validate: inputInfo.validateFunction,
        validation: null,
        errorMessage: null,
        inputValue: null
      });
    },
    checkAll: function () {
      for (var i = 0; i < this.formInputArray.length; i++) {
        var res = this.formInputArray[i].validate(true);
        this.formInputArray[i].validation = res.result;
        if (res.result) {
          this.formInputArray[i].inputValue = res.value;
        } else {
          this.formInputArray[i].errorMessage = res.value;
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/dynamic/inputWrapper/formMixin.js